// Keycloak Configuration for Production Environment
import Keycloak from 'keycloak-js';

// 항상 dump-manager-dev 클라이언트 ID 사용
const getClientId = () => {
  return process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'dump-manager-dev';
};

// Keycloak 설정
const keycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAK_URL || 'https://iam.neowiz.com',
  realm: process.env.REACT_APP_KEYCLOAK_REALM || 'neowiz',
  clientId: getClientId(),
};

console.log('Keycloak config being used:', keycloakConfig);

// Keycloak 인스턴스 생성
const keycloak = new Keycloak(keycloakConfig);

// 환경별 초기화 옵션
const getInitOptions = () => {
  const isProduction = process.env.REACT_APP_ENVIRONMENT === 'production';
  const redirectUri = process.env.REACT_APP_KEYCLOAK_REDIRECT_URI;
  
  // 안정적인 강제 로그인 설정
  return {
    onLoad: 'login-required', // 항상 로그인 필수
    checkLoginIframe: false, // iframe 체크 완전 비활성화
    checkLoginIframeInterval: 0, // 체크 간격 0
    flow: 'standard', // 표준 OAuth2 플로우
    responseMode: 'query', // query 파라미터 모드 (더 안정적)
    redirectUri: redirectUri || window.location.origin + '/callback',
    scope: 'openid profile email',
    // 타임아웃 설정
    messageReceiveTimeout: 8000, // 8초로 단축
    // 로깅 설정
    enableLogging: true,
    // 기타 안정성 설정
    adapter: 'default',
    useNonce: false,
  };
};

export const keycloakInitOptions = getInitOptions();

// 프로덕션 전용 설정 - 무한 루프 방지
export const keycloakInitOptionsForProd = {
  onLoad: 'login-required',
  checkLoginIframe: false, // iframe 체크 완전 비활성화
  checkLoginIframeInterval: 0, // 체크 간격 0
  flow: 'standard',
  enableLogging: false,
  adapter: 'default',
  useNonce: false, // nonce 비활성화
  // silentCheckSsoRedirectUri 제거 - CORS 오류 방지
};

// 개발 환경용 설정 - 무한 루프 방지
export const keycloakInitOptionsForDev = {
  onLoad: 'check-sso',
  checkLoginIframe: false, // iframe 체크 완전 비활성화
  flow: 'standard',
  enableLogging: false, // 로깅도 비활성화
  adapter: 'default',
  useNonce: false,
};

export default keycloak;
